/**
 * Non-production `VITE_APP_BUILD` tags — one per `.env.*` file in the project root.
 * An unknown tag counts as production, so a config added without extending this
 * list hides test-only features instead of leaking them to real users.
 */
const TEST_APP_BUILDS: readonly string[] = [
	'preproduction',
	'staging',
	'alpha',
	'sigma',
	'gamma',
	'omega',
	'bravo',
	'omni',
	'inspect',
];

/**
 * Returns true on every non-production deploy and on the local dev server.
 *
 * `vite dev` has no `.env.development` to load, so it falls back to the base
 * `.env` where `VITE_APP_BUILD` is `prod` — hence the extra `DEV` check.
 */
export const isTestEnvironment = (): boolean =>
	import.meta.env.DEV || TEST_APP_BUILDS.includes(import.meta.env.VITE_APP_BUILD);
